// Module
var code = `<template> <div class="row col"> <combo-box class="combo-box-in col-gutter col-12 col-md-5" selected-value.two-way="filter.vetting" selected-value-path="value" display-member-path="name" set-default.bind="true" item-source.bind="itemSource" readonly.bind="readonly" disabled.bind="disabled"></combo-box> </div> </template>`;
// Exports
module.exports = code;